import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home-view" */ '../views/HomeView.vue'),
  },
  {
    path: '/cancer-de-colo-do-utero',
    name: 'cancer-colo-utero',
    component: () => import(/* webpackChunkName: "cancer-colo-utero-view" */ '../views/CancerColoUteroView.vue'),
  },
  {
    path: '/cancer-de-mama',
    name: 'cancer-mama',
    component: () => import(/* webpackChunkName: "cancer-mama-view" */ '../views/CancerMamaView.vue'),
  },
  {
    path: '/tabagismo',
    name: 'tabagismo',
    component: () => import(/* webpackChunkName: "tabagismo-view" */ '../views/TabagismoView.vue'),
  },
  {
    path: '/sobrepeso-consumo-alimentos-ultraprocessados',
    name: 'nutricao',
    component: () => import(/* webpackChunkName: "nutricao-view" */ '../views/NutricaoView.vue'),
  },
  {
    path: '/praticas-corporais-e-atividade-fisica',
    name: 'atividade-fisica',
    component: () => import(/* webpackChunkName: "atividade-fisica-view" */ '../views/AtividadeFisicaView.vue'),
  },
  {
    path: '*',
    name: 'page-not-found',
    component: () => import(/* webpackChunkName: "page-not-found-view" */ '@/views/PageNotFoundView.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    return new Promise((resolve) => {
      if (to.hash) {
        document.fonts.ready
          .then(() => { // Ensures there is no font swap after scroll is triggered
            resolve({
              selector: to.hash,
              behavior: 'smooth',
              offset: {
                y: 53 - 1, // -1 to make sure it is inside target element
                x: 0,
              },
            });
          });
        return;
      }

      router.app.$root.$once('scrolltotop', () => {
        router.app.$nextTick(() => resolve({ x: 0, y: 0 }));
      });
    });
  },
});

export default router;
